import { useDraft, useStore } from "../hooks.ts";
import { Field } from "../ui/elemente.tsx";
import type { SurveyFields } from "../zustand.ts";

const blank = (s: string) => (s.trim() === "" ? null : s);

export function kontaktFehler(s: Pick<SurveyFields, "contactName" | "phone" | "email">) {
  const emailOk = !s.email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.email.trim());
  return {
    name: !s.contactName ? "Bitte Ihren Namen angeben." : null,
    reach: !s.phone && !s.email ? "Bitte Telefon oder E-Mail angeben." : !emailOk ? "Die E-Mail-Adresse sieht unvollständig aus." : null,
  };
}

/** Felder für Name, Telefon, E-Mail (Seite "Ihre Angaben", zusammen mit dem Termin). */
export function KontaktFelder(props: { tried: boolean }) {
  const d = useDraft();
  const store = useStore();
  const s = d.survey;
  const { name, reach } = kontaktFehler(s);
  return (
    <>
      <Field
        label="Name"
        autoComplete="name"
        value={s.contactName}
        onChange={(v) => store.updateSurvey({ contactName: blank(v) })}
        error={props.tried ? name : null}
      />
      <Field
        label="Telefon"
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        value={s.phone}
        onChange={(v) => store.updateSurvey({ phone: blank(v) })}
        error={props.tried && !s.email ? reach : null}
      />
      <Field
        label="E-Mail"
        type="email"
        inputMode="email"
        autoComplete="email"
        value={s.email}
        onChange={(v) => store.updateSurvey({ email: blank(v) })}
        hint="Telefon oder E-Mail genügt."
        error={props.tried && (s.email || !s.phone) ? reach : null}
      />
    </>
  );
}
